import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogRecommendation } from '@urbannex/product-multi-recommender';
import { NbButtonModule, NbCheckboxModule } from '@nebular/theme';
import { CategoryNode } from '../catalog-recommender.component';



@Component({
  selector: 'ubs-catalog-node',
  standalone: true,
  imports: [CommonModule,NbButtonModule,NbCheckboxModule],
  templateUrl: './catalog-node.component.html',
  styleUrls: ['./catalog-node.component.scss']
})
export class CatalogNodeComponent implements OnChanges{
  
  @Input() node!: CategoryNode;
  @Output() select = new EventEmitter<{node: CategoryNode, selected: boolean}>();

  constructor(private cdr: ChangeDetectorRef) {}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['node']){
      console.log("Node changed", this.node);
    }
  }

  toggle() {
    this.node.expanded = !this.node.expanded
    /* if(this.node.status == 'expanded'){
      this.node.status = 'collapsed';
    }else{
      this.node.status = 'expanded';
    } */
  }

  toggleSelection(selected: boolean): void {
    event.stopPropagation(); // prevent triggering parent events
    console.log("toggleSelection method called", this.node);
    console.log(`Node selected BEFORE: ${this.node.selected}`);
    this.node.selected = selected;
    this.node.indeterminate = false;
    /* let selectedState:boolean = this.node.selected;
    if(this.node.selected){
      selectedState = false;
    }else{
      selectedState = true;
    }
    this.node = { ...this.node, selected: selectedState, indeterminate: false }; */
    console.log(`Node selected AFTER: ${this.node.selected}`);
    //this.node.selected = !this.node.selected;
    //this.node.indeterminate = false;
    
    this.updateChildrenSelection(this.node, this.node.selected);
    this.select.emit({ node: this.node, selected: this.node.selected });
    //this.updateParentState(this.node)
    //this.updateParentIndeterminateState(this.node);
    //this.cdr.detectChanges();
    this.cdr.markForCheck(); // tell Angular this component needs to be re-rendered
  }
  // Recursively update children selection
  private updateChildrenSelection(node: CategoryNode, selected: boolean): void {
    console.log("updateChildrenSelection method called", node);
    node.children?.forEach(child => {
      child.selected = selected;
      child.indeterminate = false;
      this.updateChildrenSelection(child, selected);
    });
  }
  // Notify the parent nodes (up the tree) via event bubbling
  private updateParentIndeterminateState(node: CategoryNode): void {
    // Let the parent component recalculate indeterminate/selected state if needed
    // If you're storing the tree in a global structure, you'll need to traverse upward.
    // Since there's no parent reference here, this would usually be done at a higher level,
    // unless you maintain a node->parent map or traverse the full tree from the top.
  }
  private updateParentState(node: CategoryNode | undefined): void {
    console.log("updateParentState method called", node);
    if (!node?.parentId) return;
    console.log("Node has parent.  Doing some checking");
    const allSelected = node.parent.children.every(c => c.selected);
    const noneSelected = node.parent.children.every(c => !c.selected && !c.indeterminate);
  
    if (allSelected) {
      node.parent.selected = true;
      node.parent.indeterminate = false;
    } else if (noneSelected) {
      node.parent.selected = false;
      node.parent.indeterminate = false;
    } else {
      node.parent.selected = false;
      node.parent.indeterminate = true;
    }
  
    this.updateParentState(node.parent);
  }
  

  /* onSelect() {
    this.select.emit(this.node);
  } */

    /* toggleSelection(event: Event) {
      //event.stopPropagation(); // Prevent event bubbling if needed
      this.node = this.toggleNodeAndChildren(this.node);
      this.select.emit({ node: this.node, selected: this.node.selected });
      event.stopPropagation()
    } */

    private toggleNodeAndChildren(node: CategoryNode): CategoryNode {
      // Create a new node object to trigger change detection
      const updatedNode: CategoryNode = { 
        ...node,
        selected: !this.node.selected,
        indeterminate: false // Explicit toggling resets indeterminate
      };
    
      // Recursively update children immutably
      if (updatedNode.children?.length) {
        updatedNode.children = updatedNode.children.map(child => 
          this.toggleNodeAndChildren(child)
        );
      }
      //this.select.emit({ node: updatedNode, selected: updatedNode.selected });
      return updatedNode;
    }

    /* private toggleNodeAndChildren(node: CategoryNode) {
      // Toggle current node
      node.selected = !node.selected;
      node.indeterminate = false; // Reset indeterminate when explicitly toggled
  
      // Propagate to all children recursively
      if (node.children?.length) {
        node.children.forEach(child => {
          child.selected = node.selected;
          child.indeterminate = false;
          this.toggleNodeAndChildren(child); // Recursively update grandchildren
        });
      }
    } */
    
    private toggleNodeSelection(node: CategoryNode) {
      // Toggle the current node's selection
      node.selected = !node.selected;
      // Reset indeterminate state when explicitly toggled
      node.indeterminate = false;
    
      // Propagate selection to all children
      if (node.children) {
        node.children.forEach(child => {
          child.selected = node.selected;
          child.indeterminate = false; // Ensure children are not indeterminate
          if (child.children) {
            this.toggleNodeSelection(child); // Recursively update grandchildren
          }
        });
      }
    }

    /* updateParentIndeterminateState(node: CategoryNode) {
      if (!node.parentId) return;
    
      const allChildrenSelected = node.parentId.children.every(child => child.selected);
      const someChildrenSelected = node.parent.children.some(child => child.selected || child.indeterminate);
    
      node.parentId.selected = allChildrenSelected;
      node.parent.indeterminate = !allChildrenSelected && someChildrenSelected;
    
      // Recursively update ancestors
      this.updateParentIndeterminateState(node.parent);
    } */

    /* toggleSelection(event: Event) {
      console.log("toggleSelection method called");
      //event.stopPropagation();
      this.node.selected = !this.node.selected;
      console.log(this.node);
      // Emit the selection event to parent
      this.select.emit({
        node: this.node,
        selected: this.node.selected
      });
    } */
  /* toggleSelection(node: CategoryNode, event: Event) {
    event.stopPropagation();
    node.selected = !node.selected;
    
    // Apply selection to all children
    if (node.children?.length) {
      this.selectChildren(node.children, node.selected);
    }
    
    // Update parent states
    this.updateParentStates(this.catalogTree);
    
    // Emit the selection change event
    this.selectionChange.emit(this.getSelectedCategories());
  } */

  private selectChildren(children: CategoryNode[], selected: boolean) {
    children.forEach(child => {
      child.selected = selected;
      child.indeterminate = false;
      if (child.children?.length) {
        this.selectChildren(child.children, selected);
      }
    });
  }

  selectAllChildren(event: Event) {
    event.stopPropagation();
    
    // Only select children, don't change parent state
    if (this.node.children?.length) {
      this.select.emit({
        node: this.node,
        selected: true
      });
    }
  }

}
